import VideoCard from '@/components/feature/VideoCard';

interface Video {
  id: number;
  title: string;
  slug: string;
  categoryId: string;
  categoryName: string;
  thumbnail: string;
  duration: string;
  views: number;
  publishDate: string;
  author: string;
  authorAvatar: string;
  quality: string;
}

interface VideoGridProps {
  title: string;
  subtitle?: string;
  videos: Video[];
  viewAllLink?: string;
  accentColor?: 'primary' | 'accent';
}

export default function VideoGrid({
  title,
  subtitle,
  videos,
  viewAllLink,
  accentColor = 'primary',
}: VideoGridProps) {
  const accentClasses = accentColor === 'accent'
    ? 'bg-accent-500 hover:bg-accent-600'
    : 'bg-primary-500 hover:bg-primary-600';

  return (
    <section className="py-10 md:py-14">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        {/* Header */}
        <div className="flex items-end justify-between mb-6 md:mb-8">
          <div>
            <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950 mb-1">
              {title}
            </h2>
            {subtitle && (
              <p className="text-sm text-foreground-500">{subtitle}</p>
            )}
          </div>
          {viewAllLink && (
            <a
              href={viewAllLink}
              onClick={(e) => {
                e.preventDefault();
                window.REACT_APP_NAVIGATE(viewAllLink);
              }}
              className="flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 font-medium transition-colors whitespace-nowrap cursor-pointer"
            >
              查看全部 <i className="ri-arrow-right-line"></i>
            </a>
          )}
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 md:gap-5">
          {videos.map((video) => (
            <VideoCard
              key={video.id}
              id={video.id}
              title={video.title}
              thumbnail={video.thumbnail}
              duration={video.duration}
              views={video.views}
              publishDate={video.publishDate}
              author={video.author}
              authorAvatar={video.authorAvatar}
              categoryName={video.categoryName}
              categorySlug={video.categoryId}
              quality={video.quality}
              slug={video.slug}
            />
          ))}
        </div>
      </div>
    </section>
  );
}